<template>
  <NtSpacing compact class="relative">
    <div class="flex gap-6 sticky top-12 bg-white dark:bg-neutral-800 pt-3 pb-1 z-10">
      <h3 class="grow text-base font-semibold leading-6 text-neutral-900 dark:text-white">{{ name }}</h3>
      <button
        type="button"
        class="w-6 h-6 flex items-center justify-center relative rounded-md bg-white dark:bg-neutral-800 text-neutral-400 hover:text-neutral-500 dark:hover:text-white dark:ring-offset-neutral-800 focus:outline-hidden focus:ring-2 focus:ring-accent-500 focus:ring-offset-2 cursor-pointer"
        @click="dismissAll">
        <span class="absolute -inset-2.5" />
        <span class="sr-only">Dismiss all</span>
        <i class="fa-sharp fa-times fa-fw" aria-hidden="true"></i>
      </button>
    </div>
    <TransitionGroup
      move-class="transition-all duration-500"
      enter-active-class="transition-all duration-500"
      leave-active-class="transition-all duration-200 absolute"
      enter-from-class="scale-90 opacity-0"
      leave-to-class="translate-x-64 opacity-0"
      @before-leave="beforeLeave">
      <NtNotificationCard
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
        @close="$emit('close')" />
    </TransitionGroup>
  </NtSpacing>
</template>

<script>
import { mapActions } from 'pinia'
import NtSpacing from '../general/NtSpacing.vue'
import NtNotificationCard from './NtNotificationCard.vue'
import { useNotificationStore } from '@/stores/notifications'

export default {
  components: { NtSpacing, NtNotificationCard },
  emits: ['close'],
  props: {
    name: {
      type: String,
      required: true
    },
    notifications: {
      type: Array,
      required: true
    }
  },
  methods: {
    ...mapActions(useNotificationStore, ['deleteNotification']),
    dismissAll() {
      for (let i = 0; i < this.notifications.length; i++) {
        this.deleteNotification(this.notifications[i].id)
      }
    },
    beforeLeave(el) {
      const { marginLeft, marginTop, width, height } = window.getComputedStyle(el)

      el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
      el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
      el.style.width = width
      el.style.height = height
    }
  }
}
</script>
